module.exports = __webpack_public_path__ + "img/icon-score0.8d423b2c.svg";